const parseContentLinks = (element, linksArray, allSubChapters, location, language) => {
  if (element.getElementsByTagName('a').length > 0) {
    var anchorLinks = Array.from(element.getElementsByTagName('a'));
    anchorLinks.map((anchor) => {
      if (linksArray.length > 0) {
        if (anchor.getAttribute('data-item-id')) {
          let linkedItemCodename = linksArray.filter((node) => {
            return node.url_key === anchor.getAttribute('data-item-id');
          });
          let linkedContentItem = allSubChapters.filter(({
            node
          }) => {
            return node.system.codename === linkedItemCodename[0].codename;
          });
          if (linkedContentItem.length > 0) {
            linkedContentItem = linkedContentItem[0].node;

            let url = location.origin + '/';
            url += language + '/';

            if (linkedContentItem.system.type === 'chapter') {
              if (typeof linkedContentItem.usedByContentItems[0] !== 'undefined') {
                url += linkedContentItem.usedByContentItems[0].elements.url.value + '/';
              }
            } else {
              if (typeof linkedContentItem.usedByContentItems[0].usedByContentItems[0] !== 'undefined') {
                url += linkedContentItem.usedByContentItems[0].usedByContentItems[0].elements.url.value + '/';
              }
              if (typeof linkedContentItem.usedByContentItems[0] !== 'undefined') {
                url += linkedContentItem.usedByContentItems[0].elements.url.value + '/';
              }
            }
            url += linkedContentItem.elements.url.value + '/';
            anchor.href = url;
          }
        }
      }
    });
  }
};

exports.parseContentLinks = parseContentLinks;